import { hasSalonGender } from './salonGender';

export function resolveStylistGuestGender(user, profile) {
  const prefs =
    (profile && typeof profile === 'object' && profile.preferences) ||
    user?.profile?.preferences ||
    {};
  return (
    user?.gender ||
    prefs?.gender ||
    profile?.gender ||
    user?.profile?.gender ||
    ''
  );
}

export function stylistGuestGenderReady(user, profile) {
  return hasSalonGender(resolveStylistGuestGender(user, profile));
}
